// Reading streaks
import { API_BASE } from './state.js';

export async function getStreakData() {
  try {
    const res = await fetch(`${API_BASE}/streaks`, { credentials: 'include' });
    return await res.json();
  } catch {
    return { currentStreak: 0, longestStreak: 0, totalDays: 0 };
  }
}

export function renderStreakBadge(container, streakData) {
  if (!container || !streakData || streakData.currentStreak < 2) return;
  
  container.innerHTML = `
    <div class="streak-badge">
      <span class="streak-icon">🔥</span>
      <span class="streak-count">${streakData.currentStreak}</span>
      <span class="streak-label">day streak</span>
    </div>
  `;
}
